export default "__VITE_ASSET__exW8ILgP__"